module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Sleeping-Beauty.178c1ff7.jpg";